import React, { Component } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import FadeIn from "react-lazyload-fadein";
import ScrollAnimation from 'react-animate-on-scroll';
import { Link } from 'react-router-dom';

export default class ModProducts extends Component {
	render () {
		let block = this.props.block;
		const slides = block.product.map((product,i) =>
			<SwiperSlide key={i}>
				<div>
					<Link to={{ pathname: '/product/' + product.slug }}>
						<FadeIn duration={250}>
							{onload => (
								<img
									alt={product.alt} 
									src={product.src} 
									srcSet={product.srcset} 
									onLoad={onload}
								/>
							)}
						</FadeIn>
						<h4>{ product.heading }</h4>
					</Link>
				</div>
			</SwiperSlide>
		);
		return (
			<div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
				<div className="c-product-gallery c-product-gallery--no-space">
					<div className="l-content">
		    			<div className="l-grid">
		    				<div className="l-grid__col">
		    					<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
			    					{block.heading &&
			    						<h2 className="c-product-gallery__heading c-product-gallery__heading--alt">{ block.heading }</h2>
			    					}
			    					{block.link_text && block.link_url &&
				        				<a href={ block.link_url } className="c-product-gallery__link">{ block.link_text }</a>
			        				}
									<div className="scope-swiper">
										<Swiper
										spaceBetween={0}
										slidesPerView={1.25}
										breakpoints={{
											480: {
												slidesPerView: 2.25,
											},
											768: {
												slidesPerView: 3.25,
											},
											960: {
												slidesPerView: 4,
											}
										}}
										>
											{ slides }
										</Swiper>
									</div>
								</ScrollAnimation>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}